<div style="display: flex; flex-direction: row; justify-content: space-between">
  <div
    class="purchase-order-details"
    [ngClass]="{
      'full-width-container1': !showDetailSection,
      'half-width-container1': showDetailSection
    }"
    style="display: flex; flex-direction: column; overflow-x: hidden"
  >
    <div
      class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4"
      style="width: 100%"
    >
      <mat-card class="p-0" style="margin: 0 0.5rem">
        <mat-card-content #pdfContent class="ship-fscoll hgt ship-pr-sec">
          <div class="purchase-order-details-title">
            <!-- <div style="display: flex;flex-direction:row;justify-content:space-between;margin-top:10px;margin-bottom:5px">
                                <div id="purchaseOrderDetails">
                                    Create Purchase Order
                                </div>

                                <button mat-button color="primary"
                                        style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                                        (click)="close(true)">Close<mat-icon>navigate_next</mat-icon></button>
                            </div> -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;
              "
            >
              <div
                id="purchaseOrderDetails"
                style="font-size: 26px; font-weight: 949"
              >
                Invoice Details
              </div>

              <!-- Action Buttons -->
              <div style="display: flex; gap: 10px" *ngIf="!isBuyerUser">
                <button
                  mat-stroked-button
                  color="primary"
                  style="
                    font-size: 18px;
                    padding-left: 32px;
                    padding-right: 32px;
                    padding-top: 24px;
                    padding-bottom: 24px;
                    color: #42a190;
                    background-color: #d9e0e4;
                  "
                  (click)="uploadPOD()"
                >
                  Upload POD
                  <mat-icon style="color: #42a190">upload</mat-icon>
                </button>

                <button
                  mat-stroked-button
                  color="primary"
                  style="
                    font-size: 18px;
                    padding-left: 32px;
                    padding-right: 32px;
                    padding-top: 24px;
                    padding-bottom: 24px;
                    color: #42a190;
                    background-color: #d9e0e4;
                  "
                  [matMenuTriggerFor]="downloadMenu"
                >
                  Packaging Documents
                  <mat-icon style="color: #42a190">arrow_drop_down</mat-icon>
                </button>

                <mat-menu #downloadMenu="matMenu">
                  <button
                    mat-menu-item
                    (click)="onSelectDownload('Commercial Invoice')"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download Commercial Invoice</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="onSelectDownload('Packaging List')"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download Packing Slip</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="onSelectDownload('Delivery Note')"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download Delivery Note</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          <div style="width: 100%">
            <div>
              <div class="invoice-details-form">
                <span
                  style="
                    padding-left: 16px;
                    padding-top: 16px;
                    margin-bottom: 32px;
                    font-weight: bold;
                    display: flex;
                    justify-content: space-between;
                    padding-right: 20px;
                  "
                  (click)="toggleVisibility('form11')"
                >
                  Invoice Details
                  <mat-icon>{{
                    isInvoiceDetailsFormGroupExpnd ? "minimize" : "add"
                  }}</mat-icon>
                </span>

                <form
                  [formGroup]="invoiceDetailsFormGroup"
                  *ngIf="isInvoiceDetailsFormGroupExpnd"
                >
                  <div class="three-column-flex">
                    <!-- Hidden/non-UI control: invoiceId (kept in form, not shown) -->

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Invoice Number</mat-label>
                        <input
                          matInput
                          formControlName="invoiceNumber"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Invoice Date</mat-label>
                        <input
                          matInput
                          [matDatepicker]="invoiceDatePicker"
                          formControlName="invoiceDate"
                          readonly
                          [disabled]="true"
                        />
                        <mat-datepicker #invoiceDatePicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Purchase Order Number</mat-label>
                        <input
                          matInput
                          formControlName="purchaseOrderNumber"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Quote Ref Number</mat-label>
                        <input
                          matInput
                          formControlName="quoteRefNumber"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>RFQ Ref Number</mat-label>
                        <input
                          matInput
                          formControlName="rfqRefNumber"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Due Date</mat-label>
                        <input matInput formControlName="dueDate" readonly />
                      </mat-form-field>
                    </div>

                    <div
                      class="form-item-row-header"
                      style="top: 25px; position: relative"
                    >
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Payment Terms</mat-label>
                        <textarea
                          matInput
                          formControlName="paymentTerms"
                          readonly
                        ></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </form>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  overflow-x: auto;
                  width: 100%;
                  margin-top: 70px;
                "
              >
                <form [formGroup]="lineItemtableForm">
                  <ngx-datatable
                    #table
                    class="material expandable"
                    [rows]="dataSource"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [rowHeight]="'auto'"
                    [columnMode]="'force'"
                    [scrollbarH]="true"
                    [externalPaging]="false"
                    [externalSorting]="false"
                    [limit]="10"
                  >
                    <ngx-datatable-column name="S.No." [width]="100">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('position')
                          "
                          readonly
                          style="width: 40px"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Service Name">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('partNumber')
                          "
                          readonly
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Service Description">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <textarea
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('itemDescription')
                          "
                          [disabled]="true"
                          readonly
                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                          [rows]="isWrapDescription ? 4 : 1"
                          matTooltipClass="mat-tooltip-custom"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        ></textarea>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Scope of Work">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <textarea
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('scopeOfWork')
                          "
                          [disabled]="true"
                          readonly
                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                          [rows]="isWrapDescription ? 4 : 1"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        ></textarea>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Supplier Comment">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <textarea
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('supplierComment')
                          "
                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                          [rows]="isWrapDescription ? 4 : 1"
                          readonly
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        ></textarea>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Customs Code">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('customsCode')
                          "
                          readonly
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Requested Quantity">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('quantity')
                          "
                          [disabled]="true"
                          readonly
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Quoted Quantity">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('supplierQuantity')
                          "
                          (blur)="calculateRowValues(rowIndex)"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          readonly
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Requested UOM">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('uom')
                          "
                          readonly
                          style="width: 100px"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Quoted UOM">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          pattern="[A-Za-z\\s]*"
                          style="width: 100px"
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('supplierUom')
                          "
                          readonly
                          (keypress)="allowOnlyLetters($event)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column
                      name="Quoted Unit Cost"
                      [sortable]="true"
                      [width]="220"
                    >
                      <ng-template
                        ngx-datatable-header-template
                        let-column="column"
                      >
                        <div class="datatable-header-flex">
                          <span class="datatable-header-text">
                            Quoted Unit Cost
                            <span class="required-star">*</span>
                          </span>

                          <mat-slide-toggle
                            (change)="
                              getColumn('requestedUnitCost')
                                ? showToggleColumns(
                                    getColumn('requestedUnitCost')
                                  )
                                : null
                            "
                            [checked]="getColumn('requestedUnitCost')?.visible"
                            class="ml-2"
                          >
                          </mat-slide-toggle>

                          <button
                            mat-icon-button
                            style="padding: 0px"
                            [matTooltip]="
                              'Currency conversion is powered by ExchangeRate-API and locked at entry.'
                            "
                          >
                            <mat-icon>info</mat-icon>
                          </button>

                          <!-- This renders the built-in sort icon -->
                          <span
                            class="datatable-sort-icon"
                            [class.active]="column.sort?.dir"
                          >
                            <i
                              [ngClass]="{
                                'fa fa-caret-up': column.sort?.dir === 'asc',
                                'fa fa-caret-down': column.sort?.dir === 'desc'
                              }"
                            ></i>
                          </span>
                        </div>
                      </ng-template>

                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          type="number"
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('unitCost')
                          "
                          (blur)="calculateRowValues(rowIndex)"
                          [disabled]="true"
                          step="any"
                          readonly
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column
                      type="button"
                      name="Requested Unit Cost"
                    >
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <span>{{ headerData?.currencyId?.currencyCode }}</span>
                        <input
                          type="number"
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('unitCost')
                          "
                          (blur)="calculateRowValues(rowIndex)"
                          step="any"
                          [disabled]="!canEditLineItems"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Discount">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('discount').value | number: '1.3-3' }}
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column
                      name="Quoted Total Cost"
                      [sortable]="true"
                      [width]="220"
                    >
                      <ng-template
                        ngx-datatable-header-template
                        let-column="column"
                      >
                        <div class="datatable-header-flex">
                          <span class="datatable-header-text"
                            >Quoted Total Cost</span
                          >

                          <mat-slide-toggle
                            (change)="
                              getColumn('requestedTotalCost')
                                ? showToggleColumns(
                                    getColumn('requestedTotalCost')
                                  )
                                : null
                            "
                            [checked]="getColumn('requestedTotalCost')?.visible"
                            class="ml-2"
                          >
                          </mat-slide-toggle>

                          <button
                            mat-icon-button
                            style="padding: 0px"
                            [matTooltip]="
                              'Currency conversion is powered by ExchangeRate-API and locked at entry.'
                            "
                          >
                            <mat-icon>info</mat-icon>
                          </button>

                          <span
                            class="datatable-sort-icon"
                            [class.active]="column.sort?.dir"
                          >
                            <i
                              [ngClass]="{
                                'fa fa-caret-up': column.sort?.dir === 'asc',
                                'fa fa-caret-down': column.sort?.dir === 'desc'
                              }"
                            ></i>
                          </span>
                        </div>
                      </ng-template>

                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          type="number"
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('totalCost')
                          "
                          [disabled]="true"
                          step="any"
                          readonly
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column
                      type="button"
                      name="Requested Total Cost"
                    >
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        {{ headerData?.currencyId?.currencyCode }}
                        {{
                          lineItemtableForm
                            .get("rows")
                            ["controls"][rowIndex].get("totalCost").value
                            | number : "1.3-3"
                        }}
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Lead Time">
                      <ng-template
                        ngx-datatable-header-template
                        let-column="column"
                      >
                        Lead Time <span class="required-star">*</span>
                      </ng-template>
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          type="number"
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('leadTime')
                          "
                          style="width: 100px"
                          readonly
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <!-- <ngx-datatable-column type='button' *ngIf="getColumn('attachments')?.visible" name="Attachments">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button mat-icon-button (click)="toggleSidebar(true, 'attachment', rowIndex)" [disabled]="isDecline(rowIndex)">
                                        <mat-icon>add_circle</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->

                    <!-- <ngx-datatable-column name="" [width]="80">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                  
                                      <button type='button' *ngIf="!isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="toggleSidebar(true, 'decline', rowIndex)">
                                        <mat-icon>close</mat-icon>
                                      </button>

                                      <button type='button' *ngIf="isDecline(rowIndex)" mat-icon-button class="delete-icon-button" (click)="restoreLineitem(rowIndex)">
                                        <mat-icon>restore</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->
                  </ngx-datatable>
                </form>
              </div>
              <div style="margin: 30px 0px; float: none">
                <form [formGroup]="secondFormGroup">
                  <div class="cost-summary-container">
                    <!-- First Table -->
                    <table class="summary-table">
                      <tbody>
                        <tr>
                          <td>
                            <b
                              >Total
                              <span
                                *ngIf="
                                  secondFormGroup.get('supplierCurrency')?.value
                                    ?.currencyCode !== null
                                "
                              >
                                ({{
                                  secondFormGroup.get("supplierCurrency")?.value
                                    .currencyCode
                                }})
                              </span></b
                            >
                          </td>
                          <td>
                            {{
                              (secondFormGroup.get("quoteLineItemTotal")
                                ?.value || 0) | number: '1.3-3'
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Line Item list Price Sub Total</td>
                          <td>
                            <input type="hidden" formControlName="quoteLineItemListPriceSubtotal" />
                            <input type="text" matInput [value]="(secondFormGroup.get('quoteLineItemListPriceSubtotal')?.value || 0) | number: '1.3-3'" readonly />
                          </td>
                        </tr>
                        <tr>
                          <td>Line Item Discount</td>
                          <td>
                            <input type="hidden" formControlName="quoteLineItemDiscount" />
                            <input type="text" matInput [value]="(secondFormGroup.get('quoteLineItemDiscount')?.value || 0) | number: '1.3-3'" readonly />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Second Table -->
                    <table class="summary-table">
                      <tbody>
                        <tr>
                          <td>Line Item Sub Total</td>
                          <td>
                            <input type="hidden" formControlName="quoteLineItemSubtotal" />
                            <input type="text" matInput [value]="(secondFormGroup.get('quoteLineItemSubtotal')?.value || 0) | number: '1.3-3'" readonly />
                          </td>
                        </tr>
                        <tr>
                          <td>General Discount</td>
                          <td>
                            <input type="hidden" formControlName="quoteLineItemGeneralDiscountValue" />
                            <input type="text" matInput [value]="(secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value || 0) | number: '1.3-3'" readonly />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td (click)="toggleFreightDetails()">
                            Air Freight (In amount)<mat-icon>{{
                              showFreightDetails ? "expand_less" : "expand_more"
                            }}</mat-icon>
                          </td> -->
                          <td (click)="toggleFreightDetails()">
                            Freight (In amount)<mat-icon>{{
                              showFreightDetails ? "expand_less" : "expand_more"
                            }}</mat-icon>
                          </td>
                          <td>
                            <span>
                              {{ secondFormGroup.get('quoteLineItemFreightTotal')?.value | number : '1.3-3' }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Freight details table, visible only if showFreightDetails is true -->
                    <div
                      *ngIf="
                        showFreightDetails &&
                        secondFormGroup.get('quoteLineItemFreight')?.value
                      "
                      style="display: flex; flex-direction: column"
                    >
                      <table class="summary-table">
                        <thead>
                          <tr>
                            <th style="padding: 10px">Description</th>
                            <!-- <th style="padding: 10px">Cost Type</th> -->
                            <th style="padding: 10px">Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let item of secondFormGroup.get(
                                'quoteLineItemFreight'
                              )?.value
                            "
                          >
                            <td>{{ item.freightDescription }}</td>
                            <!-- <td>{{ item.freightType }}</td> -->
                            <td>{{ item.freightValue | number: '1.3-3' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Third Table -->
                    <!-- <table
                                  class="summary-table"
                                  *ngIf="freightValues.length > 0"
                                >
                                  <tbody>
                                    <tr>
                                      <td>Documentation Charges (In amount)</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quoteDocumentationCharges"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Packing Charges (In amount)</td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          formControlName="quotePackingCharges"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                    <tr class="total-row">
                                      <td><b>Total</b></td>
                                      <td>
                                        <input
                                          type="number"
                                          matInput
                                          [formControlName]="'quoteLineItemTotal'"
                                          [disabled]="true"
                                          step="any"
                                          readonly
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table> -->

                    <table class="summary-table">
                      <tbody>
                        <tr>
                          <td>Applicable Tax Profile</td>
                          <td>
                            {{ selectedTaxProfile?.applicableTaxProfile }} %
                          </td>
                        </tr>
                        <!-- <tr>
                                      <td>Tax Type</td>
                                      <td>
                                  
                                        {{quoteLineItemTaxType}}
                                      </td>
                                  </tr> -->
                        <tr>
                          <td>Tax Amount</td>
                          <td>
                            {{
                              (secondFormGroup.get("quoteLineItemTaxAmount")
                                ?.value || 0) | number: '1.3-3'
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
              <!-- <div class="secondformcontainerfull" style="margin: 30px;float:right;">
                            <form [formGroup]="secondFormGroup">
                              <div class="floating-card-container">
                                <div class="floating-card">
                                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; font-weight: bold;">
                                    <span><b>Total <span *ngIf="secondFormGroup.get('supplierCurrency')?.value?.currencyCode!== null">
                                      ({{ secondFormGroup.get('supplierCurrency')?.value.currencyCode}})
                                    </span></b></span>
                                    <span>{{secondFormGroup.get('quoteLineItemTotal')?.value || 0.00}}</span>
                                  </div>
                                  <div class="card-body mx-4">
                                     <div class="container">
                                        
                                        <div class="row">
                                          <hr>
                                          <div class="col-xl-10">
                                            <p>Line Item list Price Sub Total</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemListPriceSubtotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p>Line Item Discount</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemDiscount'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p><b>Line Item Sub Total</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'quoteLineItemSubtotal'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <hr>
                                        </div>
                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>General Discount</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="quoteLineItemGeneralDiscountType" [disabled]="true" readonly style="width: 100%; margin-bottom: 10px;">
                                                <option value="percentage">Percentage</option>
                                                 
                                                  
                                                </select>
                                              <input type="number" matInput [formControlName]="'quoteLineItemGeneralDiscountValue'"  step="any"  (blur)="calculateCostSummary()" readonly/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Applicable Tax Profile</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="hidden" formControlName="quoteLineItemApplicableTaxProfile" />
                                              <input type="text" matInput [value]="(selectedTaxProfile) + ' %'" readonly style="margin-bottom: 10px;" />
                                              <input type="hidden" [formControlName]="'quoteLineItemTaxAmount'" />
                                              <input type="text" matInput [value]="(secondFormGroup.get('quoteLineItemTaxAmount')?.value || 0) | number: '1.3-3'" readonly />

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Freight</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              
                                            </p>
                                            
                                          </div>
                                          
                                          <div style="display:flex;justify-content: flex-end;margin-bottom: 10px">
                                            <span>
                                              {{ secondFormGroup.get('quoteLineItemFreightTotal')?.value | number : '1.3-3' }}
                                            </span>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>
                                        <div class="row text-black">
                                  
                                          <div class="col-xl-12">
                                            <p class="float-end fw-bold" style="color: white !important;"> Total: 
                                              <input type="number" matInput [formControlName]="'quoteLineItemTotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>
                                      
                                  
                                      </div>
                                  </div>
                                </div>
                              </div>
                        </form>
                        </div> -->
            </div>
          </div>
          <div style="width: 100%">
            <form [formGroup]="firstFormGroup">
              <div>
                <div class="header-form-header" *ngIf="false">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('packagingDetailsForm')"
                  >

                    <div style="display: flex; align-items: center;">
                      Packaging Details

                      <button mat-icon-button matSuffix type="button" matTooltipClass="mat-tooltip-custom" matTooltipPosition="left"
                      [matTooltip]="packagingDetailsTooltip">
                      <mat-icon>info_outline</mat-icon>
                      </button>
                    </div>
                    <mat-icon>{{ isPackagingDetailsFormExpand ? 'minimize' : 'add' }}</mat-icon>
                  </span>
                
                  <div
                    *ngIf="isPackagingDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="packagingDetailsForm"
                  >
                    <!-- Total Packages -->
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>
                          Total Packages <span style="color: red;">*</span>
                        </mat-label>
                        <input
                          matInput
                          formControlName="totalPackages"
                          placeholder="Enter total packages"
                          [readonly]="invoiceAlreadySent"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          maxlength="10"
                          (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()"
                        />

                        <button mat-icon-button matSuffix type="button">
                          <mat-icon matSuffix class="valid-icon"
                              *ngIf="packagingDetailsForm.get('totalPackages')?.valid && packagingDetailsForm.get('totalPackages')?.value">
                              check_circle
                          </mat-icon>
                          <mat-icon matSuffix class="invalid-icon" *ngIf="!packagingDetailsForm.get('totalPackages')?.value">
                            cancel
                          </mat-icon>
                        </button>

                      </mat-form-field>
                    </div>
                
                    <!-- Total Net Weight -->
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>
                          Total Net Weight (kgs) <span style="color: red;">*</span>
                        </mat-label>
                        <input
                          matInput
                          formControlName="totalNetWeight"
                          placeholder="Enter total net weight"
                          [readonly]="invoiceAlreadySent"
                          inputmode="decimal"
                          pattern="^[0-9]+(\\.[0-9]{1,2})?$"
                          (keypress)="onKeyPressNumeric($event)"
                          (input)="onNetWeightInput($event)"
                        />

                        <button mat-icon-button matSuffix type="button">
                          <mat-icon matSuffix class="valid-icon"
                              *ngIf="packagingDetailsForm.get('totalNetWeight')?.valid && packagingDetailsForm.get('totalNetWeight')?.value">
                              check_circle
                          </mat-icon>
                          <mat-icon matSuffix class="invalid-icon" *ngIf="!packagingDetailsForm.get('totalNetWeight')?.value">
                            cancel
                          </mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                
                    <!-- Dimensions -->
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Dimensions (L×W×H) cms</mat-label>
                        <input
                          matInput
                          formControlName="dimensions"
                          placeholder="Enter dimensions"
                          [readonly]="invoiceAlreadySent"
                        />
                      </mat-form-field>
                    </div>
                
                    <!-- Special Handling Instructions -->
                    <div class="form-item-row-header" style="top: 25px; position: relative">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Special Handling Instructions</mat-label>
                        <textarea
                          matInput
                          formControlName="specialHandlingInstructions"
                          placeholder="Enter any special handling instructions"
                          [readonly]="invoiceAlreadySent"
                          rows="2"
                        ></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Bank Details -->
                <div class="header-form-header">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('bankDetailsForm')"
                  >
                    
                    <div style="display: flex; align-items: center;">
                      Bank Details

                      <button mat-icon-button matSuffix type="button" matTooltipClass="mat-tooltip-custom" matTooltipPosition="left"
                      [matTooltip]="bankDetailsTooltip">
                      <mat-icon>info_outline</mat-icon>
                      </button>
                    </div>
                    <mat-icon>{{
                      isBankDetailsFormExpand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div
                    *ngIf="isBankDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="banDetailsForm"
                  >
                    <div class="form-item-row-header" *ngIf="!invoiceAlreadySent">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Choose Bank Details</mat-label>
                        <mat-select
                          [value]="selectedBankDetailsId"
                          (selectionChange)="onBankDetailsSelectionChanged($event)"
                          [disabled]="invoiceAlreadySent"
                        >
                          <mat-option [value]="null" disabled>
                            Select bank details
                          </mat-option>
                          <mat-option
                            *ngFor="let bd of bankDetailsOptions"
                            [value]="bd.supplier_bank_detailsid"
                          >
                            {{ bd.bankName }} - {{ bd.accountNumberIBAN }} -
                            {{ bd.bankAccountHolderName }}
                          </mat-option>
                        </mat-select>

                        <button mat-icon-button matSuffix type="button">
                          <mat-icon matSuffix class="valid-icon"
                              *ngIf="banDetailsForm.get('supplier_bank_detailsid')?.valid && banDetailsForm.get('supplier_bank_detailsid')?.value">
                              check_circle
                          </mat-icon>
                          <mat-icon matSuffix class="invalid-icon" *ngIf="!banDetailsForm.get('supplier_bank_detailsid')?.value">
                            cancel
                          </mat-icon>
                        </button>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Bank Account Holder Name</mat-label>
                        <input
                          matInput
                          formControlName="bankAccountHolderName"
                          readonly
                        />

                        <button mat-icon-button matSuffix type="button">
                          <mat-icon matSuffix class="valid-icon"
                              *ngIf="banDetailsForm.get('bankAccountHolderName')?.valid && banDetailsForm.get('bankAccountHolderName')?.value">
                              check_circle
                          </mat-icon>
                          <mat-icon matSuffix class="invalid-icon" *ngIf="!banDetailsForm.get('bankAccountHolderName')?.value">
                            cancel
                          </mat-icon>
                        </button>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Bank Name</mat-label>
                        <input matInput formControlName="bankName" readonly />
                        <button mat-icon-button matSuffix type="button">
                          <mat-icon matSuffix class="valid-icon"
                              *ngIf="banDetailsForm.get('bankName')?.valid && banDetailsForm.get('bankName')?.value">
                              check_circle
                          </mat-icon>
                          <mat-icon matSuffix class="invalid-icon" *ngIf="!banDetailsForm.get('bankName')?.value">
                            cancel
                          </mat-icon>
                        </button>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Account Number</mat-label>
                        <input
                          matInput
                          formControlName="accountNumber"
                          readonly
                        />
                        <button mat-icon-button matSuffix type="button">
                          <mat-icon matSuffix class="valid-icon"
                              *ngIf="banDetailsForm.get('accountNumber')?.valid && banDetailsForm.get('accountNumber')?.value">
                              check_circle
                          </mat-icon>
                          <mat-icon matSuffix class="invalid-icon" *ngIf="!banDetailsForm.get('accountNumber')?.value">
                            cancel
                          </mat-icon>
                        </button>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>SWIFT/BIC Code</mat-label>
                        <input
                          matInput
                          formControlName="swiftBicCode"
                          readonly
                        />
                        <button mat-icon-button matSuffix type="button">
                          <mat-icon matSuffix class="valid-icon"
                              *ngIf="banDetailsForm.get('swiftBicCode')?.valid && banDetailsForm.get('swiftBicCode')?.value">
                              check_circle
                          </mat-icon>
                          <mat-icon matSuffix class="invalid-icon" *ngIf="!banDetailsForm.get('swiftBicCode')?.value">
                            cancel
                          </mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Buyer Company Details -->
                <div class="header-form-header">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('buyerCompanyDetailsForm')"
                  >
                    Buyer Company Details
                    <mat-icon>{{
                      isBuyerCompanyDetailsFormExpand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div
                    *ngIf="isBuyerCompanyDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="buyerCompanyDetailsForm"
                  >
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Buyer Name</mat-label>
                        <input matInput formControlName="buyerName" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Email Id</mat-label>
                        <input matInput formControlName="buyerEmail" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="buyerPhone" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Fax</mat-label>
                        <input matInput formControlName="buyerFax" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Address</mat-label>
                        <input
                          matInput
                          formControlName="buyerAddress"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Billing Address</mat-label>
                        <input
                          matInput
                          formControlName="billingAddress"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Buyer Details -->
                <div class="header-form-header">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('buyerDetailsForm')"
                  >
                    Buyer Details
                    <mat-icon>{{
                      isBuyerDetailsFormExpand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div
                    *ngIf="isBuyerDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="buyerDetailsForm"
                  >
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Contact Person (Job Title)</mat-label>
                        <input
                          matInput
                          formControlName="buyerContactPerson"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Email Id</mat-label>
                        <input
                          matInput
                          formControlName="buyerContactEmail"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Phone</mat-label>
                        <input
                          matInput
                          formControlName="buyerContactPhone"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Fax</mat-label>
                        <input
                          matInput
                          formControlName="buyerContactFax"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Address</mat-label>
                        <input
                          matInput
                          formControlName="buyerContactAddress"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Billing Address</mat-label>
                        <input
                          matInput
                          formControlName="buyerContactAddress"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Supplier Company  Details -->
                <div class="header-form-header">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('supplierCompanyDetailsForm')"
                  >
                    Supplier Company Details
                    <mat-icon>{{
                      isSupplierCompanyDetailsFormExpand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div
                    *ngIf="isSupplierCompanyDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="supplierCompanyDetailsForm"
                  >
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Contact Name</mat-label>
                        <input
                          matInput
                          formControlName="supplierContactName"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Email Id</mat-label>
                        <input
                          matInput
                          formControlName="supplierEmail"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Address</mat-label>
                        <input
                          matInput
                          formControlName="supplierAddress"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Mobile Number</mat-label>
                        <input
                          matInput
                          formControlName="supplierPhone"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Tax Number</mat-label>
                        <input
                          matInput
                          formControlName="supplierTaxNumber"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Supplier Details -->
                <div class="header-form-header">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('supplierDetailsForm')"
                  >
                    Supplier Details
                    <mat-icon>{{
                      isSupplierDetailsFormExpand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div
                    *ngIf="isSupplierDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="supplierDetailsForm"
                  >
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Contact Name</mat-label>
                        <input
                          matInput
                          formControlName="supplierContactName"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Job Title</mat-label>
                        <input matInput formControlName="jobTitle" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Email Id</mat-label>
                        <input
                          matInput
                          formControlName="supplierEmail"
                          readonly
                        />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Mobile Number </mat-label>
                        <input
                          matInput
                          formControlName="supplierPhone"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Vessel Details -->
                <div class="header-form-header">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('vesselDetailsForm')"
                  >
                    Vessel Details
                    <mat-icon>{{
                      isVesselDetailsFormExpand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div
                    *ngIf="isVesselDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="vesselDetailsForm"
                  >
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Vessel Name</mat-label>
                        <input matInput formControlName="vesselName" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Vessel IMO Number</mat-label>
                        <input
                          matInput
                          formControlName="vesselIMONumber"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Vessel Type</mat-label>
                        <input matInput formControlName="vesselType" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Class</mat-label>
                        <input
                          matInput
                          formControlName="vesselClass"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Port Details -->
                <div class="header-form-header">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                    (click)="toggleVisibility('portDetailsForm')"
                  >
                   
                    <div style="display: flex; align-items: center;">
                      Port Details

                      <button mat-icon-button matSuffix type="button" matTooltipClass="mat-tooltip-custom" matTooltipPosition="left"
                      [matTooltip]="portDetailsTooltip">
                      <mat-icon>info_outline</mat-icon>
                      </button>
                    </div>
                    <mat-icon>{{
                      isPortDetailsFormExpand ? "minimize" : "add"
                    }}</mat-icon>
                  </span>

                  <div
                    *ngIf="isPortDetailsFormExpand"
                    class="three-column-flex"
                    [formGroup]="portDetailsForm"
                  >
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Name</mat-label>
                        <input matInput formControlName="portName" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Port Code</mat-label>
                        <input matInput formControlName="portCode" readonly />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Vessel ETA</mat-label>
                        <input
                          matInput
                          [matDatepicker]="vesselETA"
                          formControlName="vesselETA"
                          readonly
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="vesselETA"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #vesselETA></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Vessel ETD</mat-label>
                        <input
                          matInput
                          [matDatepicker]="vesselETD"
                          formControlName="vesselETD"
                          readonly
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="vesselETD"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #vesselETD></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Incoterms</mat-label>
                        <input
                          matInput
                          formControlName="incoterms"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Incoterms Locations</mat-label>
                        <input
                          matInput
                          formControlName="incotermLocations"
                          readonly
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!-- Note Section -->
                <div class="header-form-header" [formGroup]="noteForm">
                  <span
                    style="
                      padding-left: 16px;
                      padding-top: 16px;
                      margin-bottom: 32px;
                      font-weight: bold;
                      display: flex;
                      justify-content: space-between;
                      padding-right: 20px;
                    "
                  >
                    Note
                  </span>
                  <!-- Supplier Note Input -->
                  <div style="padding: 0 16px 16px 16px">
                    <mat-form-field
                      class="full-width"
                      color="accent"
                      appearance="fill"
                    >
                      <mat-label>Supplier Note</mat-label>
                      <textarea
                        matInput
                        formControlName="supplierNote"
                        placeholder="Write your note here..."
                        rows="3"
                      ></textarea>
                    </mat-form-field>

                    <!-- Removed log button by request -->
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div
            style="
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 20px;
            "
          >
            <button
              mat-raised-button
              color="warn"
              (click)="closeCreateInvoicePage()"
              style="
                font-size: 18px;
                padding-left: 32px;
                padding-right: 32px;
                padding-top: 24px;
                padding-bottom: 24px;
                background-color: #d11;
              "
            >
              Close
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
<!-- Missing Fields Notification Overlay -->
<div *ngIf="showNotification">
  <div class="notification-overlay" (click)="dismissNotification()"></div>
  <div
    class="notification-popup show"
    [ngClass]="{
      'info-notification': notificationType === 'info',
      'error-notification': notificationType === 'error',
      'payment-notification': notificationType === 'payment'
    }"
  >
    <div class="notification-content">
      <h3 style="margin-top: 0; margin-bottom: 12px">{{ notificationTitle }}</h3>
      <div class="notification-message" [innerHTML]="notificationMessage"></div>
      <button type="button" class="btn-ok" (click)="dismissNotification()">
        OK
      </button>
    </div>
  </div>
</div>
